import React, { useRef, useState } from "react";
import "../../styles/ImageUploadField.css";

const API_URL = process.env.REACT_APP_API_URL;

const ImageUploadField = ({ value, onChange, disabled = false }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = "";

    setUploading(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("image", file);
      const res = await fetch(`${API_URL}/api/upload-image`, { method: "POST", body: fd });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.message || "Upload failed");
      onChange(data.url);
    } catch (err) {
      setError(err.message || "Upload failed. Try again.");
    } finally {
      setUploading(false);
    }
  };

  const displayUrl = value
    ? value.startsWith("/uploads/")
      ? `${API_URL}${value}`
      : value
    : null;

  return (
    <div className="iuf-wrap">
      {displayUrl ? (
        <div className="iuf-preview-row">
          <img src={displayUrl} alt="attachment" className="iuf-thumb" />
          <div className="iuf-preview-actions">
            <button
              type="button"
              className="iuf-change-btn"
              onClick={() => inputRef.current?.click()}
              disabled={uploading || disabled}
            >
              {uploading ? "Uploading…" : "Change"}
            </button>
            <button
              type="button"
              className="iuf-remove-btn"
              onClick={() => onChange("")}
              disabled={disabled}
            >
              Remove
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="iuf-pick-btn"
          onClick={() => inputRef.current?.click()}
          disabled={uploading || disabled}
        >
          <span className="iuf-pick-icon">↑</span>
          {uploading ? "Uploading…" : "Upload Image"}
        </button>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
      {error && <span className="iuf-error">{error}</span>}
    </div>
  );
};

export default ImageUploadField;
